import { render, staticRenderFns } from "./CampaignDetails.vue?vue&type=template&id=b37c20ec"
import script from "./CampaignDetails.vue?vue&type=script&lang=js"
export * from "./CampaignDetails.vue?vue&type=script&lang=js"
import style0 from "./CampaignDetails.vue?vue&type=style&index=0&id=b37c20ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports